// custom-actions.service.ts
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthenticationService} from "@alfresco/adf-core";
import {ActivatedRoute} from "@angular/router";
import { algAuthorizationHeader } from '../src/lib/alg-auth';

@Injectable({
  providedIn: 'root'
})
export class AddNoteService {

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private activatedRoute: ActivatedRoute) {
  }

  addNote(nom: string, note: string) {
    let url = this.activatedRoute.snapshot['_routerState'].url.split('/').pop();

    const uuidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

    if (!uuidPattern.test(url)) {
      url = "-my-";
    }
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/alfresco/versions/1/nodes/${url}/children`;

    let auth = algAuthorizationHeader(this.authService);

    // Créez un objet FormData pour construire une requête POST multipart/form-data
    const formData: FormData = new FormData();

    // Ajoutez les métadonnées du fichier en tant que partie JSON nommée "metadata"
    const fileMetadata = {
      "name": nom + ".txt",
      "nodeType":"cm:content"
    };
    formData.append('metadata', new Blob([JSON.stringify(fileMetadata)], { type: 'application/json' }));

    // Ajoutez la chaîne "note" au formulaire en tant que contenu du fichier
    formData.append('filedata', new Blob([note], { type: 'text/plain' }), nom + ".txt");

    // Effectuez la requête avec les en-têtes appropriés
    let headers = new HttpHeaders().append('Authorization', auth);

    return this.http.post(endpointUrl, formData, { headers: headers });
  }



}
